import { Link } from "gatsby";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import loadable from '@loadable/component';
import NavDropdown from "react-bootstrap/NavDropdown";
import styled from "styled-components";
import { PiPhoneLight, PiSignIn } from "react-icons/pi";
import { BsFileEarmarkExcel, BsSearch, BsPerson, BsTools } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";

import logo from "../images/clearout_new_logo_color115.png";
import { Container, Navbar, Nav } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Calendly from "./calendly";
import * as Constants from "../helpers/constants"

import { useConfig } from "../hooks/use-config";

const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  background-color: ${(props) => (props.sticky ? "whitesmoke" : "#fff")};
  box-shadow: ${(props) =>
    props.sticky ? "0 0 .5em rgba(0, 0, 0, .5)" : "auto"};
  width: 100%;
  z-index: 10000;
  transition-duration: 0.3s;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  background-size: 100% 100%;

  p,
  div {
    font-size: 14px;
  }

  .demo-btn {
    font-size: 15px;
    font-weight: 600;
  }

  #signup_button {
    padding: 5px 8px 5px 8px !important;
  }

  #signup_button:hover {
    color: #fff !important;
    background-color: #334a4a;
  }

  .developer_nav {
    cursor: pointer;
  }

  .navbar {
    min-height: ${(props) => props.height + "px"};
    justify-content: space-between;
    background-image: linear-gradient(
      to right,
      #f6ece0,
      #f5eee4,
      #f4f0e7,
      #f4f1eb,
      #f4f3ef,
      #f7f4f2,
      #f8f5f5,
      #f8f7f7,
      #faf9f9,
      #fbfbfb,
      #fdfdfd,
      #ffffff
    );
  }

  .nav-link {
    letter-spacing: 0.1px;
    font-size: 15px;
    margin: 0 10px !important;
    color: rgb(74, 69, 96) !important;
    font-weight: 600;
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .navbar-brand {
    padding-right: 0px !important;
    padding-left: 0px !important;
    margin: 0px !important;
  }

  .dd-sub-menu-title {
    color: #000000e0;
    letter-spacing: 0.1px;
    font-weight: bold;
  }

  .dd-sub-menu-desc {
    color: #00000094;
    white-space: break-spaces;
    line-height: 20px;
  }

  #navbarResponsive {
    justify-content: flex-start;
    align-items: center;
  }

  .dropdown-item {
    display: grid;
    grid-template-columns: 45px auto;
    padding-bottom: 5px;
    border: 0;
  }

  .product-styling .dropdown-item {
    grid-template-columns: 45px 288px !important;
  }

  .resource-styling {
    display: flex !important;
    justify-content: left;
    padding: 15px 15px;
  }

  .product-styling {
    display: flex !important;
    justify-content: left;
    padding: 15px 15px;
  }

  .dropdown-item:hover {
    background-color: transparent;
  }
  .text-secondary:hover {
    color: #ffa700 !important;
  }

  .dropdown-menu {
    border: none !important;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 40px !important; /* adjust this value to move the menu up or down */
    left: 0;
    margin-top: 0;
  }

  .navbar-nav > li .dropdown-menu {
    border: none;
    padding: 10px 0;
    box-shadow: 0 5px 20px rgb(0 0 0 / 33%);
  }

  .dropdown-menu {
    transition-duration: 300ms;
    animation-duration: 300ms;
    transition-timing-function: ease;
    transition-delay: 0ms;
  }

  .navbar-toggler {
    border: 0px !important;
    box-shadow: none !important;
  }

  .dropdown-second {
    position: relative;
    display: inline-block;
  }

  .dropdown-content-second {
    display: none;
    background-color: #fff;
    z-index: 1;
  }

  .dropdown-content-second a {
    color: black;
    text-decoration: none;
    display: block;
  }

  .dropdown-content-second a:hover {
    background-color: #ddd;
  }

  .dropdown-second:hover .dropdown-content-second {
    display: block;
  }

  .dropdown-second:hover .dropbtn {
    background-color: #fff;
  }

  .content-div {
    display: flex;
    width: 650px;
    text-decoration: none;
    animation: 0s ease 0s 1 normal none running none;
  }

  .drop-content {
    text-align: left;
  }

  .navbar-collapse a:hover,
  .nav-link:hover {
    color: #ffa700 !important;
  }

  .tool-text {
    font-size: 15px;
    color: #334a4a;
    font-weight: 800 !important;
  }

  .tool-link {
    margin-top: 8px;
  }

  .product-right .dropdown-item {
    padding-left: 0 !important;
  }

  .product-right svg {
    margin-top: 5px;
  }

  @media only screen and (max-width: 600px) {
    .blogs-content {
      display: none;
    }
  }


  @media (max-width: 991px) {
    .product-styling {
      flex-direction: column;
    }

    .pe-5.right-box {
      margin-top: 25px;
    }

    .product-styling .dropdown-item {
      grid-template-columns: 45px 265px !important;
    }

    .navbar-nav .show .dropdown-menu,
    .navbar-nav li:hover .dropdown-menu {
      position: static;
      float: none;
      width: 100%;
      margin-top: 0;
      background-color: #ffffff00;
      border: 1px solid #6c757d36 !important;
      -webkit-box-shadow: none;
      left: 0;
      box-shadow: none;
    }

    .getting:hover {
      background-color: orange !important;
    }
    .hover-dropdowns .dropdown-menu {
      border: none;
      box-shadow: none;
    }

    .logo {
      width: 155px;
    }

    .navbar-toggler-icon {
      width: 1.2em;
    }
  }

  .product-right .dropdown-item {
    grid-template-columns: 288px !important;
  }

  @media only screen and (max-width: 600px) {
    .blog-mob {
      display: none !important;
    }
    .mob-allblog {
      margin-top: -5px;
    }
    .mobile-view {
      margin: 0 -9px;
    }
    .content-div {
      display: block;
    }
    .dropdown-content-second {
      width: 100%;
      margin: 0 5px;
      overflow-x: hidden;
    }
   .resource-styling {
     padding: 1px !important;
  }
  }

  @media only screen and (max-width: 991px) {
    .dropdown-content-second {
      width: 300px;
    }
    .demo_button {
      margin: 10px;
      padding: 8px;
    }
  }

  @media (min-width: 992px) {
    .nav-item.dropdown:hover .dropdown-menu {
      display: block !important;
    }

    .pe-5.product-right {
      padding-left: 0 !important;
    }
    .nav-item.show.dropdown .dropdown-menu.show {
      display: none;
    }

    .dropdown-menu {
      min-width: 645px;
      margin-left: -100px;
    }

    .pe-5.right-box {
      width: 325px;
    }

    .product-left-box {
      border-right: 0.5px solid #74707094 !important;
    }
  }
 `;

const LoadableAnnouncebar = loadable(() => import('./announcebar'));

const Header = ({ siteTitle }) => {
  const { clearout: clearoutConfig } = useConfig();
  const [showCalendly, setShowCalendly] = useState(false);
  const [isStickyHeader, setStickyHeader] = useState(false);

  // this useEffect will run only once... like comp.mount()
  useEffect(() => {
    function handleScroll() {
      const currentScrollPos = this.scrollY;

      if (currentScrollPos > 0) {
        setStickyHeader(true);
      } else {
        setStickyHeader(false);
      }
    }

    // handleScroll() // call to set the initial header status..in case if there any scrollY position
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function onClickShowCalendlyModal(e) {
    e.preventDefault();
    setShowCalendly(true);
  }

  function onCloseCalendlyModal() {
    setShowCalendly(false);
  }

  return (
    <StyledHeader sticky={isStickyHeader}>

      {<LoadableAnnouncebar />}
      <Navbar expand="lg" collapseOnSelect={true} variant="light">
        <Container>
          <Nav.Link as={Navbar.Brand} eventKey={"_brand"}>
            <Link to="/">
              <img
                className="logo"
                src={logo}
                alt="clearout logo"
                width="220px"
                height="100%"
              />
            </Link>
          </Nav.Link>
          <Navbar.Toggle aria-controls="navbarResponsive" />
          <Navbar.Collapse
            id="navbarResponsive"
            className="justify-content-end"
          >
            <Nav className="text-center dropdown-hover">
              {/* Products */}
              <NavDropdown
                title="Products"
                id="basic-nav-dropdown-products"
                renderMenuOnMount={true}
                className="hover-dropdowns"
              >
                <div className="product-styling">
                  <div className="pe-5 product-left-box">
                    {/* <span className="dd-sub-menu-title px-3 fw-bolder">
                      Support
                    </span> */}
                    <NavDropdown.Item
                      as={Link}
                      to="/sales-prospecting/"
                      className="dropdown-item cg"
                    >
                      <BsPerson size={36} fill="#777" />
                      <span className="dd-sub-menu-title text-secondary">
                        Prospect
                      </span>
                      <br />
                      <span className="dd-sub-menu-desc">
                        SQL/MQL list building with high levels of personalization,
                        real-time data enrichment and prospect search
                      </span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/email-finder/"
                      className="dropdown-item"
                    >
                      <BsSearch size={30} fill="#777" />
                      <span className="dd-sub-menu-title text-secondary">
                        Email Finder
                      </span>
                      <br />
                      <span className="dd-sub-menu-desc">
                        Find individual or bulk emails by entering the person &amp;
                        company name or domain
                      </span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/email-verifier/"
                      className="dropdown-item"
                    >
                      <AiOutlineMail size={30} fill="#777" />
                      <span className="dd-sub-menu-title text-secondary">
                        Email Verifier
                      </span>
                      <br />
                      <span className="dd-sub-menu-desc">
                        Verify emails addresses individually, in bulk or through
                        API, with 99% accuracy
                      </span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="/integrations/clearout-for-sheets/"
                      className="dropdown-item"
                    >
                      <BsFileEarmarkExcel size={30} fill="#777" />
                      <span className="dd-sub-menu-title text-secondary">
                        Clearout For Sheets
                      </span>
                      <br />
                      <span className="dd-sub-menu-desc">
                        Verify email addresses directly on Google Sheets with
                        Clearout for sheets add-on
                      </span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      target="_blank"
                      href="https://clearoutphone.io/"
                      rel="noreferrer"
                      className="dropdown-item"
                    >
                      <PiPhoneLight size={30} fill="#777" />
                      <span className="dd-sub-menu-title text-secondary">
                        ClearoutPhone
                      </span>
                      <br />
                      <span className="dd-sub-menu-desc">
                        Validate phone numbers across 240+ countries in bulk, quick
                        or real time validation
                      </span>
                    </NavDropdown.Item>
                  </div>
                  <div className="pe-5 right-box product-right dropdown-item">
                    <BsTools size={24} fill="#777" />
                    <div>
                      <span className="dd-sub-menu-title fw-bolder tool-text">
                        Free Tools
                      </span>
                      <NavDropdown.Item
                        href="/disposable-email-checker/"
                        className="collasible-nav-dropdown-item tool-link"
                      >
                        <span className="text-secondary">
                          Disposable Email Checker
                        </span>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/reverse-lookup/linkedin/"
                        className="collasible-nav-dropdown-item"
                      >
                        <span className="text-secondary">
                          Reverse LinkedIn Profile Lookup Tool
                        </span>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/reverse-lookup/email"
                        className="collasible-nav-dropdown-item"
                      >
                        <span className="text-secondary">
                          Reverse Email Lookup Tool
                        </span>
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/email-list-cleaner"
                        className="collasible-nav-dropdown-item"
                      >
                        <span className="text-secondary">
                          Email List Cleaner
                        </span>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </div>
              </NavDropdown>
              {/* Resource */}
              <NavDropdown
                title="Resource"
                id="basic-nav-dropdown-resource"
                renderMenuOnMount={true}
                className="hover-dropdowns"
              >
                {/* //copy */}
                <div className="resource-styling">
                  <div className="pe-5">
                    <span className="dd-sub-menu-title px-3 fw-bolder">
                      Support
                    </span>
                    <NavDropdown.Item
                      href="/help/#create_free_clearout_account"
                      className="getting"
                    >
                      <span className="text-secondary ">Getting started</span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="/#developers"
                      className="collasible-nav-dropdown-item"
                    >
                      <span className="text-secondary">Developer</span>
                    </NavDropdown.Item>
                    <span className="dd-sub-menu-title px-3 fw-bolder">
                      API
                    </span>
                    <NavDropdown.Item
                      href="https://docs.clearout.io/api.html"
                      target="_blank"
                      rel="noreferrer"
                      className="collasible-nav-dropdown-item "
                    >
                      <span className="text-secondary">
                        Email Verification API
                      </span>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="https://docs.clearout.io/email-finder-api.html"
                      target="_blank"
                      rel="noreferrer"
                      className="collasible-nav-dropdown-item "
                    >
                      <span className="text-secondary">Email Finder API</span>
                    </NavDropdown.Item>

                  </div>
                  <div className="ps-4 right-box">
                    <span className="dd-sub-menu-title px-3 fw-bolder">
                      Blogs
                    </span>
                    <NavDropdown.Item
                      href="/blog/2023/02/13/build-strong-sales-pipeline/"
                      className="collasible-nav-dropdown-item "
                    >
                      <div className="blogs-content">
                        <span className="text-secondary">
                          How To Build a Strong Sales Pipeline?
                        </span>
                        <br />
                      </div>
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="/blog/"
                      className="collasible-nav-dropdown-item mob-allblog"
                    >
                      <span className="text-secondary">View All Blogs</span>
                      <br />
                    </NavDropdown.Item>
                    <span className="dd-sub-menu-title px-3 fw-bolder usecase">
                      Use cases
                    </span>
                    <NavDropdown.Item
                      as={Link}
                      to="/use-cases/lead-generation-solution/"
                      className="collasible-nav-dropdown-item mob-allblog"
                    >
                      <span className="text-secondary">Lead Generation</span>
                    </NavDropdown.Item>
                    <span className="dd-sub-menu-title px-3 fw-bolder">
                    Comparison Guide
                    </span>
                    <NavDropdown.Item
                      href="/email-verification-tools"
                      target="_blank"
                      rel="noreferrer"
                      className="collasible-nav-dropdown-item "
                    >
                      <span className="text-secondary">
                      Email Verification Tools
                      </span>
                    </NavDropdown.Item>
                  </div>
                </div>
              </NavDropdown>
              <Nav.Link as={Link} to="/pricing/">
                Pricing
              </Nav.Link>
              <Nav.Link href="/integrations/">Integrations</Nav.Link>
              <Nav.Link href="/email-validation-service-for-enterprise/">
                Enterprise
              </Nav.Link>
              <Nav.Link
                href={clearoutConfig.app.loginUrl}
                target="_blank"
                rel="noreferrer"
                className="nav-link"
              >
                Login
              </Nav.Link>
              <Nav.Link
                id="signup_button"
                eventKey={"_signup"}
                title="No card required | 100 free credits"
                href={clearoutConfig.app.registerUrl}
                target="_blank"
                rel="noreferrer"
                className="nav-link border rounded-1 border-opacity-75 border-secondary-subtle  border-secondary mx-10"
              >
                Try it free <PiSignIn size="25" />
              </Nav.Link>
              <Nav.Link
                as={Button}
                bsPrefix="demo_button"
                eventKey={"_demo"}
                className="btn btn-primary demo-btn"
                onClick={onClickShowCalendlyModal}
              >
                Book a 1-to-1 demo
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Calendly
        show={showCalendly}
        eventUrl={Constants.CALENDLY_URLS.BOOK_A_DEMO}
        onCloseHandler={() => {
          onCloseCalendlyModal();
        }}
      />
    </StyledHeader>
  );
};

Header.protoTypes = {
  siteTitle: PropTypes.string,
  height: PropTypes.number,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
